<template>
    <v-container fluid>
        <page-header title="Articles" icon="mdi-newspaper-variant">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createArticle">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="articles"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @onDelete="onDelete"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
        />
    </v-container>
</template>

<script>
    import articleService from '@/services/article'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Article',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                articles: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Title',
                        value: 'title'
                    },
                    {
                        text: 'Date',
                        value: 'date'
                    }
                ],
                tableKey: 'articles',
                filterFields: [
                    { key: 'title', label: 'Title', type: 'text' },
                    { key: 'content', label: 'Content', type: 'text' },
                    { key: 'date', label: 'Date', type: 'dateRange' }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/articles/${item.id}/${action}`)
            },
            createArticle() {
                this.$router.push(`/articles/create`)
            },
            fetchItems() {
                articleService.getFilteredArticles(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.articles = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(article) {
                articleService.delete(article.id).then(resp => {
                    this.fetchItems()
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
